module.exports = __webpack_public_path__ + "static/media/whatsapp.1dc3f711.webp";